module.exports = __webpack_public_path__ + "static/img/pen.cb78f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/pen.png
// module id = Iy2a
// module chunks = 1